import { useState } from "react";

export const useForceUpdate = (): [() => void, number] => {
  const [value, setValue] = useState(0);
  return [() => setValue((prev) => prev + 1), value];
};
